import Logo from '../../assets/img/personas-logo.png';
import Background from '../../assets/img/personas-cover-2.png';
import Cover from '../../assets/img/personas-cover.jpg';
import indigo from "@material-ui/core/colors/indigo";
import red from "@material-ui/core/colors/red";

export const layout = {
  name: 'personas',
  palette: {
    primary: indigo,
    secondary: red,
  },
  colors: {
    primaryColor: "#D12F2E",
    secondaryColor: "#303b43",
    warningColor: "#ff9800",
    dangerColor: "#f44336",
    successColor: "#4caf50",
    infoColor: "#2196F3",
    infoColorShadow: 'rgba(33,150,243, 0.28)',
    greyColor: "#22303A",
  },
  header: {
    projectName: 'Personas',
    logo: Logo,
    favicon: Logo,
    color: 'white',
    background: Background,
  },
  sidebar: {
    background: Background,
    overlayColor: '#3C4A54',
    borderLeft: 'none',
  },
  mainPanel: {
    paper: {
      backgroundColor: 'rgba(255,255,255,1)',
      color: 'rgba(0,0,0,.8)',
    },
    submenu: {},
    context: {
      backgroundColor: '',
    }
  },
  cover: {
    background: Cover
  }
};

